import React, { useState, useEffect } from 'react';
import { Typography, Space, Button, Alert, Modal, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import emiter, { EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY, EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL } from '../../../../events'

import { getSameCityPRCarDetail, sameCityPRCarCancel } from 'hooks/carRental/store';
import SPButton from "../../base/SPButton";

interface props {
  enums?: any;
  data?: any;
  permission?: any;
}

const { Title, Text } = Typography

const SPSamCityRemoteReturnPage: React.FC<props> = (props) => {
  const { enums, data, permission } = props;
  const [sameCityPRCarDetail, setSameCityPRCarDetail] = useState<any>({});
  const [modal, contextHolder] = Modal.useModal();

  const sameCityPRCarIsOpen = sameCityPRCarDetail?.active === 1;


  const onOpenSwitch = () => {
    if (sameCityPRCarIsOpen) {
      modal.confirm({
        title: '提示',
        icon: <ExclamationCircleOutlined />,
        content: '确认关闭同城异店还车吗',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          handleSameCityPRCarCancel();
        }
      });
    } else {
      emiter.emit(EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY, sameCityPRCarDetail);
    }
  }

  const handleCityPRCarEdit = () => {
    emiter.emit(EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY, sameCityPRCarDetail);
  };

  const handleSameCityPRCarCancel = () => {
    sameCityPRCarCancel({}).then((res: any) => {
      const { errno } = res || {};
      if (errno === 0) {
        message.success('操作成功');
        handleSameCityPRCarDetailGet();
      }
    });
  }

  const handleSameCityPRCarDetailGet = () => {
    getSameCityPRCarDetail({}).then((res: any) => {
      const { errno, data }= res || {};
      data?.pay_conf?.forEach((item: any) => {
        item.fee = item.fee / 100;
      });
      if (errno === 0) {
        setSameCityPRCarDetail(data);
      }
    });
  }

  const tipsNode = () => (
    <>
      <div>异店还车后车辆仍归属原取车门店。</div>
      <div>用户下单后，同城还车默认额外占用2小时库存，跨城还车会根据下方路线设置时间占用库存。</div>
    </>
  )

  useEffect(() => {
    handleSameCityPRCarDetailGet();
    emiter.on(EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL, handleSameCityPRCarDetailGet);
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL)
    }
  }, []);

  return (
    <div>
      <Alert
        message={tipsNode()}
        type="info"
        showIcon
        style={{ margin: '20px 0' }}
      />
      <Space style={{ justifyContent: 'space-between', display:'flex'}}>
        <Title level={3}>同城异店取/还车设置</Title>
        <Space>
          {sameCityPRCarIsOpen && <Text type="success">已开启</Text>}
          {sameCityPRCarIsOpen && <SPButton permission={permission} permissionKey='store_same_city_pr_car_active' type="primary" onClick={handleCityPRCarEdit}>编辑</SPButton>}
          {
              sameCityPRCarIsOpen ?
            <SPButton permission={permission} permissionKey='store_same_city_pr_car_cancel' type="primary" onClick={onOpenSwitch}>{ '关闭'}</SPButton>
            :
            <SPButton permission={permission} permissionKey='store_same_city_pr_car_active' type="primary" onClick={onOpenSwitch}>{ '开通' }</SPButton>
          }

          {contextHolder}
        </Space>
      </Space>
      <Title level={5} type="secondary">开通后默认运营城市都支持同城异店取还车，包含普通门店及取送网点</Title>
      {sameCityPRCarIsOpen &&
        <div>
          <Title level={4} style={{ display: 'inline-block' }}>收费标准：</Title>
          {sameCityPRCarDetail.need_pay === 1 ? <div>
            {
              (sameCityPRCarDetail?.pay_conf || []).map((item: any, index: number) => {
                return (
                  <>
                    {index < (sameCityPRCarDetail?.pay_conf || []).length - 1 && <p>门店间距 {item.min_kilo}KM~{item.max_kilo}KM（含）收费{item.fee}元 </p> }
                    {index === (sameCityPRCarDetail?.pay_conf || []).length - 1 && <p>门店间距 {item.min_kilo}KM 以上收费{item.fee}元 </p>}
                  </>
                )
              })
            }
          </div> : <span style={{ color: 'red', verticalAlign: '1px', fontSize: '16px' }}>不收取费用</span>}
          {/* <Button>修改</Button> */}
        </div>
      }
    </div>
  )
}

export default SPSamCityRemoteReturnPage;
